import Vue from "vue";
import Router from "vue-router";
import nav from "@/views/nav";
import introduceHome from "@/views/introducePage/home";
import introduceFunction from "@/views/introducePage/function";
import introduceCourse from "@/views/introducePage/course";
Vue.use(Router);

//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "indexPage",
      component: nav,
      redirect: {
        path: "/introduceHome"
      },
      children: [
        {
          path: "/introduceHome",
          name: "introduceHome",
          component: introduceHome,
          meta: {
            title: ["介绍页-中潮教育企业端平台"],
            status: true
          }
        },
        {
          path: "/function",
          name: "function",
          component: introduceFunction,
          meta: {
            title: ["功能页-中潮教育企业端平台"],
            status: false
          }
        },
        {
          path: "/course",
          name: "course",
          component: introduceCourse,
          meta: {
            title: ["优质课程-中潮教育企业端平台"],
            status: false
          }
        }
      ]
    },
    {
      path: "/coursestore",
      name: "coursestore",
      component: resolve =>
        require(["@/views/introducePage/coursestore/navbar"], resolve),
      redirect: {
        path: "/store"
      },
      children: [
        {
          path: "/store",
          name: "store",
          component: resolve =>
            require(["@/views/introducePage/coursestore/store"], resolve),
          meta: {
            title: ["课程商城-中潮教育企业端平台"],
            status: false
          }
        },
        {
          path: "/courseInfo",
          name: "courseInfo",
          component: resolve =>
            require(["@/views/introducePage/coursestore/courseInfo"], resolve),
          meta: {
            title: ["课程详情-中潮教育企业端平台"],
            status: false
          }
        },
        {
          path: "/course/playVideo",
          name: "playVideo",
          component: resolve =>
            require(["@/views/introducePage/watchVideo/playVideo"], resolve),
          meta: {
            title: ["录播视频播放-中潮教育企业端平台"],
            status: false
          }
        },
        {
          path: "/course/liveVideo",
          name: "liveVideo",
          component: resolve =>
            require(["@/views/introducePage/watchVideo/liveVideo"], resolve),
          meta: {
            title: ["直播视频播放-中潮教育企业端平台"],
            status: false
          }
        },
        {
          path: "/course/shopCart",
          name: "shopCart",
          component: resolve =>
            require(["@/views/introducePage/coursestore/shopCart"], resolve),
          meta: {
            title: ["购物车-中潮教育企业端平台"],
            status: false
          }
        },
        {
          path: "/course/makeSureOrder",
          name: "makeSureOrder",
          component: resolve =>
            require([
              "@/views/introducePage/coursestore/makeSureOrder"
            ], resolve),
          meta: {
            title: ["确认订单-中潮教育企业端平台"],
            status: false
          }
        },
        {
          path: "/course/payforSuc",
          name: "payforSuc",
          component: resolve =>
            require(["@/views/introducePage/coursestore/payforSuc"], resolve),
          meta: {
            title: ["支付成功-中潮教育企业端平台"],
            status: false
          }
        }
      ]
    },
    {
      path: "/home",
      name: "home",
      component: resolve => require(["@/views/home"], resolve),
      redirect: {
        path: "/index"
      },
      children: [
        {
          path: "/index",
          name: "index",
          component: resolve => require(["@/views/index/index"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/class",
          name: "class",
          component: resolve => require(["@/views/class/class"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/class/playVideo",
          name: "classPlayVideo",
          component: resolve => require(["@/views/class/playVideo"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/class/liveVideo",
          name: "liveVideo",
          component: resolve => require(["@/views/class/liveVideo"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/noticeList",
          name: "noticeList",
          component: resolve => require(["@/views/notice/noticeList"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/noticeList/nticeMain",
          name: "nticeMain",
          component: resolve => require(["@/views/notice/nticeMain"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/newsList",
          name: "newsList",
          component: resolve => require(["@/views/news/newsList"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/college",
          name: "college",
          component: resolve => require(["@/views/college/college"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/CreateCollege",
          name: "CreateCollege",
          component: resolve =>
            require(["@/views/college/CreateCollege"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/college_CJ",
          name: "college_CJ",
          component: resolve =>
            require(["@/views/college/college_CJ"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/college_ZT",
          name: "college_ZT",
          component: resolve =>
            require(["@/views/college/college_ZT"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/college_Th",
          name: "college_Th",
          component: resolve =>
            require(["@/views/college/college_Th"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/college/join",
          name: "CollegeJoin",
          component: resolve =>
            require(["@/views/college/CollegeJoin"], resolve)
        },
        {
          path: "/settings",
          name: "settings",
          component: resolve => require(["@/views/user/settings"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/order/orderMain/:id",
          name: "orderMain",
          component: resolve => require(["@/views/user/orderMain"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/order",
          name: "order",
          component: resolve => require(["@/views/user/order"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/invoice",
          name: "invoice",
          component: resolve => require(["@/views/user/invoice"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/questionnaire",
          name: "questionnaire",
          component: resolve =>
            require(["@/views/questionnaire/index"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/questionnaire/details",
          name: "details",
          component: resolve =>
            require(["@/views/questionnaire/details"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/questionnaire/finish",
          name: "finish",
          component: resolve =>
            require(["@/views/questionnaire/finish"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/questionnaire/success",
          name: "details",
          component: resolve =>
            require(["@/views/questionnaire/success"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/Userauth",
          name: "Userauth",
          component: resolve => require(["@/views/Userauth"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/live",
          name: "live",
          component: resolve => require(["@/views/live/index"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/livePlay",
          name: "livePlay",
          component: resolve => require(["@/views/live/livePlay"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/exam",
          name: "exam",
          component: resolve => require(["@/views/exam/examCenter"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/exambefore",
          name: "exambefore",
          component: resolve => require(["@/views/exam/exambefore"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/classList",
          name: "classList",
          component: resolve => require(["@/views/class/classList"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/examUser",
          name: "examUser",
          component: resolve => require(["@/views/exam/examUser"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/examstart",
          name: "examstart",
          component: resolve => require(["@/views/exam/examstart"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/examresult",
          name: "examresult",
          component: resolve => require(["@/views/exam/examresult"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/examresultDetail",
          name: "examresultDetail",
          component: resolve =>
            require(["@/views/exam/examresultDetail"], resolve),
          meta: {
            role: true
          }
        },
        // {
        //   path: 'login',
        //   name: 'login',
        //   component: resolve => require(['@/views/login'], resolve),
        //   meta: {
        //     role: true
        //   },
        // },
        {
          path: "/assess",
          name: "assess",
          component: resolve => require(["@/views/assess/index"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/assessUser",
          name: "assessUser",
          component: resolve => require(["@/views/assess/assessUser"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/assessStart",
          name: "assessStart",
          component: resolve =>
            require(["@/views/assess/assessStart"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/assessResult",
          name: "assessResult",
          component: resolve =>
            require(["@/views/assess/assessResult"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/assessDetail",
          name: "assessDetail",
          component: resolve =>
            require(["@/views/assess/assessDetail"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/public",
          name: "Public",
          component: resolve => require(["@/views/public/index"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/public/info",
          name: "PublicInfo",
          component: resolve => require(["@/views/public/info"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/public/play",
          name: "PublicPlay",
          component: resolve => require(["@/views/public/play"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/public/live",
          name: "PublicLive",
          component: resolve => require(["@/views/public/live"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/statistics",
          name: "Statistics",
          component: resolve => require(["@/views/statistics/index"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/certificate",
          name: "certificate",
          component: resolve => require(["@/views/certificate/index"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/certificate/certificate",
          name: "certificateInfo",
          component: resolve =>
            require(["@/views/certificate/certificate"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/myCertificateList",
          name: "myCertificateList",
          component: resolve =>
            require(["@/views/myCertificateList/index"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/playCertVideo",
          name: "playCertVideo",
          component: resolve =>
            require(["@/views/myCertificateList/playVideo"], resolve)
        },
        {
          path: "/examMain",
          name: "examMain",
          component: resolve =>
            require(["@/views/myCertificateList/examMain"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/msgMain",
          name: "msgMain",
          component: resolve =>
            require(["@/views/myCertificateList/msgMain"], resolve)
        },
        {
          path: "/certificateStore",
          name: "certificateStore",
          component: resolve =>
            require(["@/views/certificate/certificateStore"], resolve),
          meta: {
            role: true
          }
        },
        {
          path: "/randomTestCenter",
          name: "randomTestCenter",
          component: resolve =>
            require([
              "@/views/myCertificateList/testCenter/randomGetTest"
            ], resolve),
          meta: {}
        },
        {
          path: "/testStart",
          name: "testStart",
          component: resolve =>
            require([
              "@/views/myCertificateList/testCenter/testStart"
            ], resolve),
          meta: {}
        },
        {
          path: "/testSuccess",
          name: "testSuccess",
          component: resolve =>
            require([
              "@/views/myCertificateList/testCenter/testSuccess"
            ], resolve),
          meta: {}
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: resolve => require(["@/views/login"], resolve)
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js